enum WellKnownKey {
  ShowToolCalls = "ShowToolCalls",
  RecoveringConversationIds = "RecoveringConversationIds",
  CollectionsTreeCollapsedCollectionCategoryIds = "CollectionsTreeCollapsedCollectionCategoryIds",
}
export default WellKnownKey;
